import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiComment = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M6 14H18V12H6V14ZM6 11H18V9H6V11ZM6 8H18V6H6V8ZM22 22L18 18H4C3.45 18 2.97917 17.8042 2.5875 17.4125C2.19583 17.0208 2 16.55 2 16V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V22ZM18.85 16L20 17.125V4H4V16H18.85Z" />
  </SvgWrapper>
);
